<template>
  <div class="global-action-sheet">
    <van-action-sheet
      v-model="show"
      :cancel-text="$t('openAccount.t000028')"
      @close="handleClose"
      @cancel="handleCancel"
    >
      <div class="actions-box">
        <div class="item van-hairline--bottom" v-for="action in actions" :key="action.type">
          <template v-if="action.type != 'online'">
            <template v-if="isApp">
              <a @click="handleSelect(action)">{{action.name}}</a>
            </template>
            <template v-else>
              <a :href="`${action.type === 'phone' ? 'tel' : 'mailto'}:${action.value}`">{{action.name}}</a>
            </template>
          </template>
          <template v-else>
            <div @click="handleSelect(action)" class="service"> 
              {{action.name}}
              <p class="subTitle">{{action.subname}}</p>
              <van-icon name="arrow" />
            </div>
          </template>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { ActionSheet, Icon } from 'vant';
import { getBrowser } from "@/utils/browser";

const browser = getBrowser();

export default {
  name: "GlobalActionSheet",
  components: {
    [ActionSheet.name]: ActionSheet,
    [Icon.name]: Icon
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      customerServiceUrl: '',
      customerServiceEmail: '',
      customerServicePhone: '',
      isApp: browser.isApp,
      enumLoaded: false,
      enumLoading: false
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    actions() { 
      return [
        { name: this.$t('m000024'), subname: this.$t('m000025'), url: this.customerServiceUrl, type: 'online' },
        { name: `${this.$t('m000026')}：${this.customerServicePhone || '+852 2187 2100'}`, type: 'phone', value: this.customerServicePhone || '+852 2187 2100' },
        { name: `${this.$t('m000027')}：${this.customerServiceEmail || 'cs@goingf.hk'}`, type: 'email', value: this.customerServiceEmail || 'cs@goingf.hk' }
      ];
    }
  },
  watch: {
    show: {
      handler(val) {
        if (val && !this.enumLoaded && !this.enumLoading) {
          this.loadCustomerServiceEnum();
        }
      },
      immediate: true
    }
  },
  methods: {
    async loadCustomerServiceEnum() {
      this.enumLoading = true;
      try {
        const res = await this.$apis.getEnum({
          key: "customerServiceEmail,customerServiceUrlApp,customerServicePhone",
          customLoading: true
        });
        const emailData = res.find(item => item.key === "customerServiceEmail");
        const urlData = res.find(item => item.key === "customerServiceUrlApp");
        const phoneData = res.find(item => item.key === "customerServicePhone");
        this.customerServiceEmail = emailData?.value || "cs@goingf.hk";
        this.customerServiceUrl = urlData?.value || "";
        this.customerServicePhone = phoneData?.value || "+852 2187 2100";
        this.enumLoaded = true;
      } catch (e) {
        // 使用默认值
      } finally {
        this.enumLoading = false;
      }
    },
    handleClose() {
      this.show = false;
      this.$emit("close");
    },
    handleCancel() {
      this.show = false;
      this.$emit("close");
    },
    handleSelect(action) {
      if (this.isApp) {
        if (action.type === 'online') {
          window.open(action.url, '_blank');
        } else {
          this.$JsBridge.callHandler('jumpPage', {
            type: 2,
            url: {
              phone: 'callPhone',
              email: 'sendEmail'
            }[action.type],
            data: action.value
          });
        }
      } else if (action.type === 'online') {
        window.open(action.url, '_blank');
      }
    }
  }
};
</script>

<style scoped lang="less">
.actions-box {
  padding: 0 20px;
  .item {
    display: flex;
    justify-content: center;
    line-height: 100px;
    font-size: 30px;
    
    a {
      color: #0F0F2F;
      font-weight: 400;
    }
    .service {
      line-height: 40px;
      text-align: center;
      padding: 10px 0;
      position: relative;
      width: 100%;
      color: #0F0F2F;
      p {
        font-size: 24px;
        color: #747377;
      }
      .van-icon {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 32px;
      }
    }
  }
}

/deep/ .van-action-sheet {
  padding-top: 50px;
  .black-theme & {
    .actions-box {
      .item {
        a {
          color: #fff;
        }
      }
    }
  }
  .van-action-sheet__cancel {
    font-size: 30px !important;
  }
  .van-hairline--bottom::after {
    border-bottom-color: #f3f3f3;
  }
  .van-action-sheet__gap {
    height: 0 !important;
  }
}

.black-theme {
  .actions-box {
    .service {
      color: white;
      .subTitle {
        color: #9D9D9F;
      }
    }
    .item {
      a {
        color: white;
      }
    }
  }
  .van-hairline--bottom::after {
    border-bottom-color: #323442 !important;
  }
}
</style> 
